export function getDebugGroup(): string {
	const searchParams = new URLSearchParams(window.location.search.substring(1));

	if (Boolean(searchParams.get('adengine_debug'))) {
		return searchParams.get('adengine_debug');
	}

	return searchParams.get('identity_debug');
}
